module.exports = __webpack_public_path__ + "img/404.af0fb42f.jpg";